{
  "CSServiceForms": {
    "wizard": {
      "steps": {
        "claimType": {
          "disabled": "Voit valita kerralla vain yhden asetuksen mukaisen korvauksen.",
          "required": "Valitse jokin vaihtoehto."
        }
      }
    }
  },
  "NTServiceForms": {
    "fields": {
      "cpapDeviceBatteryOption": {
        "label": "Onko sinulla CPAP-laitteellesi oma akku?",
        "required": "Ole hyvä ja valitse jokin vaihtoehto.",
        "cpapDeviceBatteryNo": "Ei",
        "cpapDeviceBatteryYes": "Kyllä"
      },
      "cpapDeviceBatteryDetails": {
        "label": "Kerro akun teho wattitunteina (Wh).",
        "required": "Tämä kenttä on pakollinen."
      },
      "cpapDeviceModel": {
        "label": "Merkki ja malli",
        "required": "Merkki ja malli ovat pakollisia tietoja."
      },
      "medicalEquipment": {
        "cpapDevice": "CPAP-laite (Jos laitetta ei käytetä lennon aikana, lentoyhtiön hyväksyntää ei tarvita. Jos käytössä uniapnean hoitoon, MEDIF-lomaketta ei tarvita)"
      }
    },
    "specialAssistanceForm": {
      "cpapNoBatteryDisclaimer": "<p>Koska emme voi taata sähkövirtaa lennolla, varauduthan siihen, että pystyt tarvittaessa pärjäämään lennon ajan ilman laitettasi.</p>"
    }
  }
}
